/** Wallet numbers are 10 digits, e.g. 3643808961. */
export const WALLET_NUMBER_PATTERN = /^\d{10}$/

const CLICKUP_TASK_URL = 'https://app.clickup.com/t/'

/**
 * Where a stored ClickUp reference should link to. New allocations store the full link, older
 * ones a bare task ID (e.g. `869fb07hk`), which is linked to the task. Anything else isn't
 * linked, so a stored value can never become a `javascript:` href.
 */
export const getClickUpUrl = (ref?: string): string | undefined => {
  const value = ref?.trim()
  if (!value) return undefined
  if (/^https?:\/\//i.test(value)) return value
  if (/^[a-z0-9]+$/i.test(value)) return `${CLICKUP_TASK_URL}${value}`
  return undefined
}

/**
 * A rejected allocation's message (the 400's `detail`), in support's terms. The API's own
 * wording is kept for anything not recognised, e.g. a reference that was already transferred.
 */
export const getAllocationErrorMessage = (detail?: string): string => {
  if (!detail) return "The allocation didn't go through. Please try again."
  if (/10-digit wallet number/i.test(detail)) return "That isn't a valid wallet number. Wallet numbers are 10 digits."
  if (/no wallet found/i.test(detail)) return 'No wallet was found with this number.'
  return detail
}
